// Initialize BlockSuite custom elements first
import '@/components/blocksuite/effects'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { ThemeProvider } from '@/components/theme-provider'
import { Toaster } from 'sonner'

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Preload auth page image for better UX
const preloadImage = (src: string) => {
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.href = src
  document.head.appendChild(link)
}

// Preload the auth pages image
preloadImage('https://ui.shadcn.com/placeholder.svg')

// Enable MSW in development
if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === 'true') {
  const { worker } = await import('./mocks/server')
  await worker.start()
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="thoughtfabric-ui-theme">
      <RouterProvider router={router} />
      <Toaster
        theme="system"
        icons={{
          success: null,
          error: null,
          warning: null,
          info: null,
        }}
        toastOptions={{
          className: 'sonner-toast',
          classNames: {
            toast: 'bg-background text-foreground border-border',
            description: 'text-muted-foreground',
            actionButton: 'bg-primary text-primary-foreground',
            cancelButton: 'bg-muted text-muted-foreground',
            closeButton:
              'bg-background text-foreground border-border hover:bg-muted',
            success: 'bg-background text-foreground border-border',
            error: 'bg-background text-foreground border-border',
            warning: 'bg-background text-foreground border-border',
            info: 'bg-background text-foreground border-border',
          },
        }}
      />
    </ThemeProvider>
  </React.StrictMode>
)
